import { collection, doc, orderBy, query, where } from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { OrderedMap } from "immutable";
import PropTypes from "prop-types";
import { collectionData, docData } from "rxfire/firestore";
import { Subject } from "rxjs";
import { map, tap } from "rxjs/operators";

import { firestore } from "../firebase";

export const subject = new Subject();

let data = OrderedMap();
let syncAt = 0;

export function getData() {
  return data.toArray().map(([, item]) => item);
}

export function clear() {
  data = OrderedMap();
  syncAt = 0;
}

export const collectionName = (investorId) =>
  `investors/${investorId}/accepted-investment-rounds`;

export const propTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

export const store = {
  getDocRef: (id, investorId) => {
    return doc(firestore, collectionName(investorId), id);
  },
  getById: (id, investorId, getData = true) => {
    const docRef = store.getDocRef(id, investorId);

    return getData ? docData(docRef, { idField: "id" }) : docRef;
  },
  list: (investorId) => {
    const projectsRef = query(
      collection(firestore, collectionName(investorId)),
      orderBy("updatedAt", "desc"),
      where("updatedAt", ">", Timestamp.fromMillis(syncAt))
    );

    return collectionData(projectsRef, { idField: "id" }).pipe(
      map((items) => {
        const newItems = OrderedMap(items.map((i) => [i.id, i]));
        const newData = newItems.mergeWith(
          (oldVal, newVal) => oldVal || newVal,
          data
        );
        data = newData;

        return data
          .toArray()
          .map(([, item]) => item)
          .sort((a, b) => {
            return (
              b.createdAt.toDate().getTime() - a.createdAt.toDate().getTime()
            );
          });
      }),
      tap(() => (syncAt = new Date().getTime()))
    );
  },
};
